import script from "./router_4IV716.vue?vue&type=script&setup=true&lang=js"
export * from "./router_4IV716.vue?vue&type=script&setup=true&lang=js"

import "./router_4IV716.vue?vue&type=style&index=0&id=bf7f0876&lang=scss&scoped=true"

import exportComponent from "/www/auto.37games.com/@mono/buildSpace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bf7f0876"]])

export default __exports__